export default "__VITE_ASSET__a498d1e5__"